import { connect } from "react-redux";
import { setWarningMessage } from "../../../messages/actions";
import { forgotPassword } from "../actions";
import { ForgotPasswordComponent } from "./ForgotPasswordComponent";
import { reduxForm } from "redux-form";
import { translate } from "react-i18next";
const mapStateToProps = state => ({
  phase: state.account.phase
});

const mapDispatchToProps = dispatch => ({
  onSubmit: values => {
    if (!values.email) {
      dispatch(setWarningMessage("E-mail can't be empty"));
      return;
    }

    dispatch(forgotPassword(values.email));
  }
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  reduxForm({
    form: "forgot-password"
  })(translate("translations")(ForgotPasswordComponent))
);



// WEBPACK FOOTER //
// ./src/users/loggedUser/ForgotPassword/index.js